import { render, staticRenderFns } from "./DDProfilMenu.vue?vue&type=template&id=3b5b5708"
import script from "./DDProfilMenu.vue?vue&type=script&lang=js"
export * from "./DDProfilMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports